// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_file__WTC5t {
  width: 31%;
  margin: 0 1%;
  height: 150px;
  display: flex;
  margin-bottom: 10px;

}

.styles_fileContainer__fjVLg {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.1);
  min-height: 50px;


}

.styles_fileSectionPosition__EMRVu {
  top: 42px !important;
  left: 10px !important;
}

/* .fileBackground{
    background: #ccc
  } */
.styles_file__WTC5t img,
.styles_file__WTC5t video {
  width: auto;
  max-width: 100%;
  max-height: 100%;

}

.styles_frowardedMessage__XWcle {
  position: absolute;
  top: -20px;
  left: 0;
  width: 100%;
  background: rgba(250, 250, 250, 0.5);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.styles_start__2Uatz {
  position: absolute;
  top: 5px;
  left: 5px;
}

.styles_removeFav__ho7CK {
  position: absolute;
}

.styles_downloadIcon__8aef0 {
  position: absolute;
  top: 10px;
  left: 10px;
  cursor: pointer;
  padding: 4px;
  /* background: rgba(0,0,0,0.6); */
  border-radius: 4px;
  color: unset !important;
  filter: unset !important;
  border-radius: 5px;
  /* background: #075B52; */
  width: 30px;
  height: 30px;
  padding: 8px;
  margin: 0;
}

.styles_locationIcon__IHAdY {
  position: absolute;
  top: 10px;
  left: 10px;
  cursor: pointer;
  padding: 4px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  color: unset !important;
  filter: unset !important;
  border-radius: 5px;
  /* background: #075B52; */
  width: 30px;
  height: 30px;
  padding: 7px;
}

/* .absoluteName{
    max-width:86%;
    position: absolute;
    top:10px;
    right:10px;
    cursor:pointer;
    padding: 4px;
    font-size:12px;
    background: rgba(0,0,0,0.6);
    border-radius: 4px;
    color: #fff;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -moz-text-size-adjust: auto;
  } */`, "",{"version":3,"sources":["webpack://./../src/renderer/components/FileTypeComponent/styles.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;;AAErB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;;;AAGlB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;KAEK;AACL;;EAEE,WAAW;EACX,eAAe;EACf,gBAAgB;;AAElB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,WAAW;EACX,oCAAoC;EACpC,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,uBAAuB;EAEvB,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,uBAAuB;EAEvB,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;;;;;;;;;;;;;;;;;;KAkBK","sourcesContent":[".file {\n  width: 31%;\n  margin: 0 1%;\n  height: 150px;\n  display: flex;\n  margin-bottom: 10px;\n\n}\n\n.fileContainer {\n  width: 100%;\n  height: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.1);\n  min-height: 50px;\n\n\n}\n\n.fileSectionPosition {\n  top: 42px !important;\n  left: 10px !important;\n}\n\n/* .fileBackground{\n    background: #ccc\n  } */\n.file img,\n.file video {\n  width: auto;\n  max-width: 100%;\n  max-height: 100%;\n\n}\n\n.frowardedMessage {\n  position: absolute;\n  top: -20px;\n  left: 0;\n  width: 100%;\n  background: rgba(250, 250, 250, 0.5);\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.start {\n  position: absolute;\n  top: 5px;\n  left: 5px;\n}\n\n.removeFav {\n  position: absolute;\n}\n\n.downloadIcon {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  cursor: pointer;\n  padding: 4px;\n  /* background: rgba(0,0,0,0.6); */\n  border-radius: 4px;\n  color: unset !important;\n  -webkit-filter: unset !important;\n  filter: unset !important;\n  border-radius: 5px;\n  /* background: #075B52; */\n  width: 30px;\n  height: 30px;\n  padding: 8px;\n  margin: 0;\n}\n\n.locationIcon {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  cursor: pointer;\n  padding: 4px;\n  background: rgba(0, 0, 0, 0.6);\n  border-radius: 4px;\n  color: unset !important;\n  -webkit-filter: unset !important;\n  filter: unset !important;\n  border-radius: 5px;\n  /* background: #075B52; */\n  width: 30px;\n  height: 30px;\n  padding: 7px;\n}\n\n/* .absoluteName{\n    max-width:86%;\n    position: absolute;\n    top:10px;\n    right:10px;\n    cursor:pointer;\n    padding: 4px;\n    font-size:12px;\n    background: rgba(0,0,0,0.6);\n    border-radius: 4px;\n    color: #fff;\n    word-break: break-all;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-box-orient: vertical;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -moz-text-size-adjust: auto;\n  } */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"file": `styles_file__WTC5t`,
	"fileContainer": `styles_fileContainer__fjVLg`,
	"fileSectionPosition": `styles_fileSectionPosition__EMRVu`,
	"frowardedMessage": `styles_frowardedMessage__XWcle`,
	"start": `styles_start__2Uatz`,
	"removeFav": `styles_removeFav__ho7CK`,
	"downloadIcon": `styles_downloadIcon__8aef0`,
	"locationIcon": `styles_locationIcon__IHAdY`
};
export default ___CSS_LOADER_EXPORT___;
